export interface HeroTheme {
  id: string;
  name: string;
  description: string;
  imageUrl: string;
  overlayColor: string; // HSL color for text readability overlay
}

// Cache-busting version - increment when images are updated
const THEME_IMAGE_VERSION = 'v2';

export const heroThemes: HeroTheme[] = [
  {
    id: 'serene-sky',
    name: 'Serene Sky',
    description: 'Soft clouds and gentle blue tones',
    imageUrl: `/images/themes/serene-sky.jpg?${THEME_IMAGE_VERSION}`,
    overlayColor: 'hsla(210, 40%, 20%, 0.3)',
  },
  {
    id: 'eternal-garden',
    name: 'Eternal Garden',
    description: 'Delicate flowers in soft pink and lavender',
    imageUrl: `/images/themes/eternal-garden.jpg?${THEME_IMAGE_VERSION}`,
    overlayColor: 'hsla(300, 20%, 20%, 0.25)',
  },
  {
    id: 'quiet-forest',
    name: 'Quiet Forest',
    description: 'Peaceful woodland with misty atmosphere',
    imageUrl: `/images/themes/quiet-forest.jpg?${THEME_IMAGE_VERSION}`,
    overlayColor: 'hsla(120, 30%, 15%, 0.3)',
  },
  {
    id: 'peaceful-waters',
    name: 'Peaceful Waters',
    description: 'Calm ocean waves in soft blue and teal',
    imageUrl: `/images/themes/peaceful-waters.jpg?${THEME_IMAGE_VERSION}`,
    overlayColor: 'hsla(200, 40%, 20%, 0.3)',
  },
  {
    id: 'sunset-horizon',
    name: 'Sunset Horizon',
    description: 'Warm golden light with soft orange and purple',
    imageUrl: `/images/themes/sunset-horizon.jpg?${THEME_IMAGE_VERSION}`,
    overlayColor: 'hsla(30, 30%, 20%, 0.25)',
  },
  {
    id: 'mountain-mist',
    name: 'Mountain Mist',
    description: 'Majestic peaks with soft morning fog',
    imageUrl: `/images/themes/mountain-mist.jpg?${THEME_IMAGE_VERSION}`,
    overlayColor: 'hsla(220, 25%, 20%, 0.3)',
  },
];

export const getThemeById = (id: string | null | undefined): HeroTheme => {
  return heroThemes.find((theme) => theme.id === id) || heroThemes[0];
};

export const DEFAULT_THEME_ID = 'serene-sky';
